import React, { useEffect, useState, useRef } from "react";
import { Image, Modal } from "react-bootstrap";
import edit from "./edit.module.css";
import questionmark from "../../../../assets/images/questionmark.png";
import editicontwo from "../../../../assets/images/editicontwo.png";
import age from "../../../../assets/images/age.png";
import gender from "../../../../assets/images/gender.png";
import locationedit from "../../../../assets/images/locationedit.png";
import relisionedit from "../../../../assets/images/relisionedit.png";
import educationedit from "../../../../assets/images/educationedit.png";
import carear from "../../../../assets/images/carear.png";
import editlogo from "../../../../assets/images/editlogo.png";
import height from "../../../../assets/images/height.png";
import intersts from "../../../../assets/images/intersts.png";
import kids from "../../../../assets/images/kids.png";
import familplantwo from "../../../../assets/images/familplantwo.png";
import smoking from "../../../../assets/images/smoking.png";
import drinktwo from "../../../../assets/images/drinktwo.png";
import prefarance from "../../../../assets/images/prefarance.png";
import helpandsupport from "../../../../assets/images/helpandsupport.png";
import setting from "../../../../assets/images/setting.png";
import Carddetails from "../../Components/card/editcard";
import { Link, useNavigate } from "react-router-dom";
import EditPicture from "../PictureEdit/pictureedit";
import { useProfile } from "../../../userflow/components/context/ProfileContext";
import { useAlert } from "../../../../Context/AlertModalContext";
import { useCookies } from "../../../../hooks/useCookies";
import { useQuestion } from "../../../../Context/QuentionContext.jsx";

const Edit = () => {
  const { profile } = useProfile();
  const Navigate = useNavigate();
  const [showRejectedModal, setShowRejectedModal] = useState(false);
  const [showInfo, setShowInfo] = useState(false);
  const [expandsall, setexpandall] = useState(false);
  const [Rejected, setRejected] = useState(false);
  const alert = useAlert();
  const { getCookie } = useCookies();
  const approvalstatus = getCookie("approval");
  const { updateQuestion } = useQuestion();
  const [newQuestion, setNewQuestion] = useState({});

  const toggleInfoVisibility = () => {
    setShowInfo(!showInfo);
  };

  function navigateTo(path) {
    if (Rejected) {
      setShowRejectedModal(true);
    } else {
      Navigate(path);
    }
  }

  useEffect(() => {
    setNewQuestion(updateQuestion);
  }, [updateQuestion]);

  useEffect(() => {
    const expandsall = localStorage.getItem("expandsall");
    setexpandall(expandsall ? expandsall === "true" : false);
  }, []);

  const calculateAge = (birthday) => {
    const birthDate = new Date(birthday);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDifference = today.getMonth() - birthDate.getMonth();

    // If the current month is before the birth month, or it's the birth month but the current day is before the birth day, subtract one year
    if (
      monthDifference < 0 ||
      (monthDifference === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }

    return age;
  };

  const expandall = () => {
    setexpandall(!expandsall);
    localStorage.setItem("expandsall", !expandsall);
  };

  useEffect(() => {
    if (window.location.pathname === "/user/pause") {
      return;
    }
    // setProfileData(profile);
    if (profile?.ApprovalTitle === "REJECTED") {
      setRejected(true);
    }
  }, [profile]);

  const handleEdit = () => {
    if (newQuestion?.length > 0) {
      alert.setModal({
        show: true,
        message:
          " Please note that changes to your written prompts will be reviewed by our admin team before going live. This process may take up to 48 hours.",
        title: "",
      });
    } else {
      Navigate("/updateanswer");
    }
  };

   return (
    <div style={{ marginTop: "1rem", paddingBottom: "100px" }}>
      <EditPicture Images={profile?.medias} />
      
      {/* About Me Header */}
      <div className={edit.aboutme}>
        <RejectModal show={showRejectedModal} setShow={setShowRejectedModal} />
        <div className="d-flex align-items-center">
          <p>About me</p>
          <Image
            onClick={toggleInfoVisibility}
            style={{ marginLeft: "8px", cursor: "pointer", opacity: 0.7 }}
            width="20px"
            height="20px"
            src={questionmark}
          />
          <div className={`${edit.whyInfo} ${showInfo ? edit.show : edit.hide}`}>
            <p>
              Please note that changes to your written prompts will be reviewed
              by our admin team before going live. This process may take up to
              48 hours, but you can continue using your account without any
              interruptions while we review & approve your updates.
            </p>
          </div>
        </div>
        <div>
          <Image
            className={edit.editIconBtn}
            style={{ cursor: "pointer", width: "24px", height: "24px" }}
            onClick={() => handleEdit()}
            src={editicontwo}
          />
        </div>
      </div>

      <div>
        {profile?.question_answers?.map((item, index) =>
          item?.answer_type === "existing" ? (
            <div
              key={`${item?.question_id}-existing-${index}`}
              className={edit.aboutdetails}
            >
              <p className={edit.aboutquestion}>{item.question}</p>
              <p className={edit.aboutanswer}>{item.answer}</p>
            </div>
          ) : null
        )}

        {newQuestion?.length > 0 && (
          <>
            <div className={edit.underreview}>
              <p>
                Please note that changes to your written prompts will be
                reviewed by our admin team before going live. This process may
                take up to 48 hours.
              </p>
            </div>
            {profile?.question_answers?.map((item, index) => (
              <>
                {item?.answer_type === "update_request" && (
                  <div
                    key={`${item?.question_id}-${index}`}
                    className={edit.aboutdetails}
                  >
                    <p className={edit.aboutquestion}>{item.question}</p>
                    <p className={edit.aboutanswer}>{item.answer}</p>
                  </div>
                )}
              </>
            ))}
          </>
        )}
      </div>

      <div className={edit.aboutme}>
        <div className="d-flex align-items-center">
          <p>Personality</p>
        </div>
        <div>
          <Image
            className={edit.editIconBtn}
            style={{ cursor: "pointer", width: "24px", height: "24px" }}
            onClick={() => Navigate("/personalityupdate")}
            src={editicontwo}
          />
        </div>
      </div>
      <div className={edit.personalityarray}>
        {profile?.Personalities?.length > 0
          ? profile?.Personalities?.map((personality, index) => (
              <div key={`${personality?.id}-${index}`} className={edit.tag}>
                {personality?.name}
              </div>
            ))
          : "No Personalities Added"}
      </div>

      <div>
        <div className="edittext-logo" style={{ margin: "2rem 0 1rem 0", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <p className="textofedit" style={{ margin: 0, fontWeight: 600, color: "#6b7280", fontSize: "0.9rem" }}>Tap to edit</p>
          <div>
            <Image className="editlogo" src={editlogo} width={20} />
          </div>
        </div>
        
        {/* Card Group */}
        <div style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
            <Link to="/updateage" style={{ textDecoration: 'none' }}>
              <Carddetails
                icon={age}
                title="Age"
                detail={profile?.Birthday ? calculateAge(profile?.Birthday) : "N/A"}
              />
            </Link>
            
            <div
              onClick={() =>
                alert.setModal({
                  show: true,
                  title: "",
                  message:
                    "Sorry, this section can't be changed. Please contact our admin for help or create a new account. Thanks!",
                })
              }
              style={{ cursor: "not-allowed", opacity: 0.7 }}
            >
              <Carddetails
                icon={gender}
                title="Gender"
                detail={
                  profile?.Gender === "Other"
                    ? "Non-Binary"
                    : (profile?.Gender === "Men"
                        ? "Man"
                        : profile?.Gender === "Women"
                        ? "Woman"
                        : "") || "N/A"
                }
              />
            </div>

            <Link to="/wantgender" style={{ textDecoration: 'none' }}>
              <Carddetails
                icon={gender}
                title="Interested in"
                detail={
                  profile?.PreferredGender === "Other"
                    ? "All"
                    : profile?.PreferredGender || "N/A"
                }
              />
            </Link>
            <Link to="/updatelocations" style={{ textDecoration: 'none' }}>
              <Carddetails
                icon={locationedit}
                title="Location"
                detail={profile?.Country ? profile?.Country : "N/A"}
              />
            </Link>
            <Link to="/updatereligion" style={{ textDecoration: 'none' }}>
              <Carddetails
                icon={relisionedit}
                title="Religion"
                detail={profile?.Religion ? profile?.Religion : "N/A"}
              />
            </Link>

          {!expandsall && (
            <button className={edit.upgradebutton} onClick={expandall}>
              Expand All
              <span style={{ marginLeft: "10px", display: "flex" }}>
                <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1L6 6L11 1" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </span>
            </button>
          )}

          {expandsall && (
            <>
              <Link to="/updateeducations" style={{ textDecoration: 'none' }}>
                <Carddetails
                  icon={educationedit}
                  title="Education"
                  detail={profile?.StudyField ? profile?.StudyField : "N/A"}
                />
              </Link>
              <Link to="/updatejob" style={{ textDecoration: 'none' }}>
                <Carddetails
                  icon={carear}
                  title="Career"
                  detail={profile?.JobTitle ? profile?.JobTitle : "N/A"}
                />
              </Link>
              <Link to="/updateheight" style={{ textDecoration: 'none' }}>
                <Carddetails
                  icon={height}
                  title="Height"
                  detail={profile?.Height ? profile?.Height : "N/A"}
                />
              </Link>

              <Link to="/updatelanguage" style={{ textDecoration: 'none' }}>
                <Carddetails
                  icon={intersts}
                  title="Language"
                  detail={
                    profile?.languages?.map((e) => e.name).join(", ") ?? "N/A"
                  }
                />
              </Link>

              <Link to="/updatekids" style={{ textDecoration: 'none' }}>
                <Carddetails
                  icon={kids}
                  title="What about kids"
                  detail={profile?.HaveChildren ? profile?.HaveChildren : "N/A"}
                />
              </Link>
              <Link to="/updatefamilyplan" style={{ textDecoration: 'none' }}>
                <Carddetails
                  icon={familplantwo}
                  title="Family plans"
                  detail={profile?.WantChildren ? profile?.WantChildren : "N/A"}
                />
              </Link>
              <Link to="/updatesmoke" style={{ textDecoration: 'none' }}>
                <Carddetails
                  icon={smoking}
                  title="Do you smoke?"
                  detail={profile?.Smoker ? profile?.Smoker : "N/A"}
                />
              </Link>
              <Link to="/updatedrink" style={{ textDecoration: 'none' }}>
                <Carddetails
                  icon={drinktwo}
                  title="Do you drink"
                  detail={profile?.Drinker ? profile?.Drinker : "N/A"}
                />
              </Link>
              
              <button className={edit.upgradebutton} onClick={expandall} style={{ marginTop: "1rem", background: "#f3f4f6", color: "#4b5563", boxShadow: "none" }}>
                Collapse
                <span style={{ marginLeft: "10px", display: "flex" }}>
                   <svg width="13" height="7" viewBox="0 0 13 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M11.5 6L6.5 1L1.5 6" stroke="#4b5563" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                   </svg>
                </span>
              </button>
            </>
          )}
        </div>
      </div>

      <div>
        <div
          style={{
            display: "flex",
            marginTop: "20px",
            justifyContent: "space-between",
            gap: "10px",
          }}
        >
          <div
            className={edit.button}
            onClick={() => navigateTo("/user/preferences")}
          >
            <img src={prefarance} alt="Preferences Icon" />
            Preferences
          </div>

          <div
            className={edit.button}
            onClick={() => Navigate("/helpsupport")}
          >
            <img src={helpandsupport} alt="Help Icon" />
            Help & Support
          </div>
        </div>
        <div className={edit.buttondiv}>
          <div
            className={edit.buttonlarge}
            onClick={() => Navigate("/accoutsetting")}
          >
            <img src={setting} alt="Settings Icon" />
            Account settings
          </div>
        </div>
      </div>
    </div>
  );
};

export default Edit;

function RejectModal({ show, setShow }) {
  return (
    <Modal
      centered
      className="customer-modal-without-header-footer selfie-modal"
      show={show}
      onHide={() => setShow(false)}
    >
      <Modal.Body className="selfie-modal-body">
        Your profile is currently not approved. Please update your profile to
        access this feature.
        <div>
          <button
            type="submit"
            className="global-save-button"
            onClick={() => setShow(false)}
          >
            Okay
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
}
